import React from 'react';

import { A11yWrapper } from 'components/a11y-wrapper';
import { t } from 'state/intl/translations';
import { AccessibleMainContent } from 'state/ui';

import SectionHeading from '../section-heading';

const YourCartHeading: React.FC = () => {
  return (
    <A11yWrapper>
      <AccessibleMainContent>
        <SectionHeading testID="cart-section-heading-label">{t('yourCart')}</SectionHeading>
      </AccessibleMainContent>
    </A11yWrapper>
  );
};

export default YourCartHeading;
